export default "__VITE_ASSET__CVcy6Xq9__"